import { useEffect } from 'react';

const BUILD_TIME = __BUILD_TIME__;

export function useVersionCheck() {
  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { buildTime } = await res.json();
        if (buildTime && buildTime !== BUILD_TIME) {
          window.location.reload();
        }
      } catch {
        // réseau indisponible — pas de reload
      }
    };

    // Vérification au démarrage
    check();

    // Re-vérification quand l'onglet redevient visible (retour PWA)
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);
}
